import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './index.scss';
import '../scss/public.scss';
import Color from '@tool/color';
import GradeTable from './grade-table';
import TimeTab from '../../component/time-tab';
import moDetail, {
  initDetailRate, changeYear,
} from './store';
import moIndex from '../../store/index';
import Empty from '@/component/empty';

interface IProps {}
interface IState {}

// 涨薪率 - 细分职能涨薪率
const DetailCategoryRate = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const {
    currentYear, years,
    tableHead, tableList,
  } = moDetail;
  const { industry } = moIndex;
  const descArr = [
    "统计说明：此处采用两种方法计算细分职能涨薪率",
    "1.所有公司的薪酬变化：在相同行业、城市、时间组合下，计算各职能的薪酬中位数，然后计算薪酬的同比变化率",
    "2.相同公司相同职能的薪酬变化：在相同公司、城市、时间组合下，计算各职能的薪酬中位数，然后计算薪酬的同比变化率",
  ];

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="detail-category-rate_10">
      <p className="one-11">
        <strong>细分职能涨薪率</strong>
        <span className="tag-02">{industry.name}</span>
      </p>
      <p className="one-13 one-166" style={{ color: '#878787' }}>
        {descArr.map((text: any, ix: number) => (
          <span key={ix}>{text}</span>
        ))}
      </p>

      {!isEmpty(tableList) ? (
        <section className="box-159">
          <GradeTable tableHead={tableHead} tableArr={tableList} />
        </section>
      ) : <Empty padding="50px 0" />}

      {!isEmpty(tableList) ? (
        <TimeTab list={years} active={currentYear} onChange={changeYear} />
      ) : null}
    </section>
  );
};

export default observer(DetailCategoryRate);
